/**
 * Harbour venue emails — owner first, then extra users. Copy goes to the
 * clipboard (semicolon-separated). Never mailto:.
 */

import { copyHarbourText } from 'src/utils/harbourPhone'

function normalizeHarbourEmail(value) {
  const email = String(value || '').trim()
  if (!email || !email.includes('@')) {
    return ''
  }
  return email
}

export function getHarbourVenueEmails(source = {}) {
  const emails = []
  const seen = new Set()

  const add = value => {
    const email = normalizeHarbourEmail(value)
    if (!email) {
      return
    }
    const key = email.toLowerCase()
    if (seen.has(key)) {
      return
    }
    seen.add(key)
    emails.push(email)
  }

  add(source.contact?.email)
  const users = Array.isArray(source.users) ? source.users : []
  const owner = users.find(user => user.isOwner)
  add(owner?.email)
  for (const user of users) {
    if (user?.isOwner) {
      continue
    }
    add(user?.email)
  }
  return emails
}

export function formatHarbourEmailsForCopy(emails = []) {
  return (Array.isArray(emails) ? emails : [])
    .map(normalizeHarbourEmail)
    .filter(Boolean)
    .filter((email, index, list) => {
      const key = email.toLowerCase()
      return list.findIndex(item => item.toLowerCase() === key) === index
    })
    .join('; ')
}

export async function copyHarbourEmails(source = {}) {
  const emails = Array.isArray(source) ? source : getHarbourVenueEmails(source)
  return copyHarbourText(
    formatHarbourEmailsForCopy(emails),
    'No emails to copy',
  )
}
